import Lightbox from './lightbox';

const VIMEO_IFRAME = '<iframe src="https://player.vimeo.com/video/[[videoId]]?[[params]]" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
const YOUTUBE_IFRAME = '<iframe src="https://www.youtube-nocookie.com/embed/[[videoId]]?[[params]]" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';

let _defaultOptions = {
  lightboxId: 'lightbox-video',
  lightboxEmbedId: 'lightbox-embed',
  videos: '.js-video-lightbox',
  loadedClass: 'has-loaded',
  dataVideoProvider: 'data-video-provider',
  dataVideoId: 'data-video-id',
  hasLoadedClass: 'has-loaded',

  provider: 'vimeo',
  vimeoParams: [
    'title=0',
    'autoplay=1',
    'portrait=1',
    'byline=0',
    'badge=1'
  ],
  youtubeParams: [
    'autoplay=1',
    'rel=0',
    'playsinline=1'
  ],
};

class LightboxVideo extends Lightbox {

  constructor(options) {
    const superOptions = Object.assign({}, _defaultOptions, options);

    super(superOptions);

    this.$embed;
    this.$player;

    this._openFromHashIndex();

    return this;

  }

  close() {
    super.close();
    this.$lightbox.classList.remove(this.options.hasLoadedClass);
    this.$embed.innerHTML = '';
    if (history.pushState) {
      history.pushState(null, null, '#');
    } else {
      location.hash = '';
    }

  }

  hasLoaded() {
    this.$lightbox.classList.add(this.options.hasLoadedClass);
  }

  view(videoId = null, videoProvider = this.options.provider) {

    const embedString = this._getEmbedString(videoId, videoProvider);

    if (!embedString) return;

    this.$embed.innerHTML = embedString;

    this.$player = this.$embed.querySelector('iframe');
    this.$player.addEventListener('load', this.hasLoaded.bind(this));

    if (history.pushState) {
      history.pushState(null, null, `#${videoId}`);
    } else {
      location.hash = `#${videoId}`;
    }

    this.open();

  }

  _getEmbedString(videoId, videoProvider) {
    const provider = videoProvider === 'youtube' ? 'youtube' : 'vimeo';

    if (!this._isValidVideoId(videoId, provider)) return '';

    const params = provider === 'youtube'
      ? this.options.youtubeParams.slice(0)
      : this.options.vimeoParams.slice(0);

    params.push('player_id=' + new Date().getTime());

    const iframe = provider === 'youtube' ? YOUTUBE_IFRAME : VIMEO_IFRAME;

    return iframe
      .replace('[[videoId]]', videoId)
      .replace('[[params]]', params.join('&'));
  }

  _isValidVideoId(videoId, videoProvider) {
    return videoProvider === 'youtube'
      ? (/^[A-Za-z0-9_-]{11}$/).test(videoId)
      : (/^[0-9]+$/).test(videoId);
  }

  _onVideoMessage(evt) {
    if (!(/^https?:\/\/player.vimeo.com/).test(evt.origin)) {
      return false;
    }
    if (this.playerOrigin === '*') {
      this.playerOrigin = evt.origin;
    }
    if (typeof evt.data !== 'string') {
      return false;
    }

    let data = null;

    try {
      data = JSON.parse(evt.data);
    } catch (err) {
      if (err) {
        return false;
      }

      return false;
    }

    switch (data.event) {
      case 'ready':
        this.hasLoaded();
        break;
      case 'playProgress':
        break;
      case 'pause':
        break;
      case 'finish':
        break;
    }
  }

  _handleImageClick(evt) {

    evt.preventDefault();
    const target = evt.currentTarget;

    const videoId = target.getAttribute(this.options.dataVideoId);
    const videoProvider = target.getAttribute(this.options.dataVideoProvider) || this.options.provider;

    if (!videoId) return;

    this.$lightbox.classList.remove(this.options.loadedClass);

    setTimeout(() => {
      this.view(videoId, videoProvider);
    }, 100);

  }

  _openFromHashIndex() {

    let hash = window.location.hash.replace('#', '');
    let video;

    if (!hash && this.isOpen) {
      this.close();
      return;
    } else if (!hash && !this.isOpen) {
      return;
    }

    for (let i = 0; i < this.$videos.length; i++) {
      const videoId = this.$videos[i].getAttribute(this.options.dataVideoId) || '';
      if (videoId.indexOf(hash) !== -1) {
        video = this.$videos[i];
        break;
      }
    }

    if (video) {
      video.click();
    }

  }

  _getElements() {

    if (!super._getElements()) return false;

    this.$videos = Array.prototype.slice.call(document.querySelectorAll(this.options.videos));
    this.$embed = document.getElementById(this.options.lightboxEmbedId);

    return true;

  }

  _events() {

    super._events();

    let i = this.$videos.length;
    while (i--) {
      this.$videos[i].addEventListener('click', this._handleImageClick.bind(this));
    }

    window.addEventListener('message', this._onVideoMessage.bind(this), false);

    if (window.history) {
      window.onpopstate = this._openFromHashIndex.bind(this);
    }

  }

}

module.exports = LightboxVideo;
